const theme = {
  globals: {
    "#YIWP-app": {
      width: "100%",
      overflowX: "hidden",
      position: "relative",
      minHeight: "100vh"
    },
    "*": {
      margin: 0,
      padding: 0,
    },
    div: {
      boxSizing: "border-box"
    },
    ul: {
      boxSizing: "border-box"
    },
    li: {
      boxSizing: "border-box"
    },
    button: {
      boxSizing: "border-box"
    },
    p: {
      color: "#051D39"
    },
    h1: {
      margin: "1em 0",
      color: "#051D39"
    },
    button: {
      cursor: "pointer"
    },
    body: {
      fontFamily: '"Museo Sans", sans-serif',
      fontWeight: 300,
      backgroundColor: "#f8f9fb",
      height: "100%",
      "& div#YIWP-app": {}
    },
    html: {
      height: "100%"
    },
    ul: {
      listStyle: "none"
    }
  },
  center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    position: "fixed",
    width: "100%",
    left: 0,
    top: 0,
    flexWrap: "wrap",
    alignContent: "center"
  },
  button: {
    disabled: {
      opacity: 0.35,
      cursor: "auto"
    },
    error: {
      borderColor: "#e60000 !important",
      transition: "border 500ms"
    }
  },
  wrapper: {
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    margin: 0,
    margin: "0 auto",
    paddingLeft: "33px",
    paddingRight: "33px",
    paddingTop: "37px",
    paddingBottom: "20px"
  },
  wrapperFixedWidth: {
    maxWidth: "1140px",
    minWidth: "1140px"
    // overflowY: "hidden"
  }
};

export const storybookTheme = {
  name: "DEFAULT",
  variables: theme
};

const darkTheme = {
  name: "DARK",
  variables: {
    backgroundColor: "black",
    textColor: "white",
    borderRadius: "100px"
  }
};

export default theme;
